import { HtmlContentProperty } from '../../../interfaces/html-content-property';
import { pdsUtils } from '../../../pds-utils';
import { HtmlContentTarget } from '../../../interfaces/html-content-target';

// the table property finds the closest table ancestor
export const tableAncestor: HtmlContentProperty = {
  name: 'table',
  value: (target: HtmlContentTarget) => pdsUtils.getClosest(target.element, 'table') as HTMLTableElement | undefined
};
